/** GSC KPI formatters — SQL returns CTR on 0–100 scale (e.g. 5.25 = 5.25%). */

const COMPACT_COUNT_THRESHOLD = 1_000_000;

const toSafeNumber = (value: number): number =>
  Number.isFinite(value) ? value : 0;

const countFormatter = new Intl.NumberFormat("en-US");
const compactCountFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 2,
});

export const formatGscCtr = (value: number): string =>
  `${toSafeNumber(value).toFixed(2)}%`;

export const formatGscPosition = (value: number): string =>
  toSafeNumber(value).toFixed(1);

/** Position bands for detail table color coding (mock: green ≤10, amber ≤20). */
export type GscPositionTone = "good" | "ok" | "neutral";

export const getGscPositionTone = (value: number): GscPositionTone => {
  const position = toSafeNumber(value);
  if (position > 0 && position <= 10) return "good";
  if (position <= 20) return "ok";
  return "neutral";
};

export const getGscPositionToneClass = (value: number): string => {
  const tone = getGscPositionTone(value);
  if (tone === "good") return "signal-text-positive font-medium";
  if (tone === "ok") return "signal-text-warning font-medium";
  return "text-muted-foreground";
};

export const formatGscCount = (value: number): string => {
  const safe = toSafeNumber(value);
  if (Math.abs(safe) >= COMPACT_COUNT_THRESHOLD) {
    return compactCountFormatter.format(safe);
  }
  return countFormatter.format(safe);
};

const chartTickFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

/** Y-axis ticks for trend charts (e.g. 2K, 4K). */
export const formatGscChartTick = (value: number): string => {
  const safe = toSafeNumber(value);
  if (Math.abs(safe) >= 1000) {
    return chartTickFormatter.format(safe);
  }
  return countFormatter.format(safe);
};
